import { useAuth } from '@/store/auth/auth.store';

/**
 * Whether the signed-in user is on the service on a temporary contract. A temporary member hires
 * only temporary crew and makes nobody permanent; the people service refuses anything else.
 */
export const useTemporaryMember = (serviceId?: string | null): boolean =>
  useAuth((state) => !!state.session?.services?.find((x) => x.service_id === serviceId)?.contract);
